import styled from 'styled-components';
import { mt } from '@lendi-ui/spacing';

interface DialogContentProps {
  centered?: boolean;
}

export const DialogContent = styled.div<DialogContentProps>`
  text-align: ${(props) => (props.centered ? 'center' : 'left')};
`;

export const ButtonsWrapper = styled.div`
  button:not(:first-child) {
    ${mt('sm')};
  }
`;
